import React from 'react';
import { MostRecent } from '@rsos/components/capstone/Location';
import { LocationsWrapper } from './styles/Locations.styles';

const Locations = () => {
  return (
    <LocationsWrapper data-name="location-list">
      <MostRecent />
    </LocationsWrapper>
  );
};

export default Locations;
